//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
  postLogin,
} from "../../../helpers/fakebackend_helper";
import Cookies from 'js-cookie';

import { loginRequest, loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from './reducer';
import { setAuthUser } from "../../../helpers/utils";
import { toast } from "react-toastify";
import { fetchUserModule } from "../../thunks";
import { t } from "i18next";

export const generateDeviceId = () => {
  const navigatorInfo = window.navigator.userAgent + window.navigator.language;
  const screenInfo = `${window.screen.height}x${window.screen.width}x${window.screen.colorDepth}`;
  const timestamp = new Date().getTime();

  // Basic hash function
  const hashString = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash |= 0; // Convert to 32bit integer
    }
    return hash.toString(16);
  };

  return `${hashString(navigatorInfo)}-${hashString(screenInfo)}-${timestamp}`;
};


export const loginUser = (user, history, refreshToken = null) => async (dispatch) => {
  dispatch(loginRequest()); // Set loading to true
  try {
    const deviceId = generateDeviceId();
    const response = await postLogin({
      email: user.email,
      password: user.password,
      Maker: navigator.platform,
      Model: navigator.userAgent.split(" ")[0],
      DeviceID: deviceId,
      Platform: "Web",
      AppVersion: "0.0.1",
      FCMToken: "0"
    });
    
    if (response.success) {
      toast.success(t(response.message));
      
      dispatch(loginSuccess(response));
      Cookies.set('deviceId', deviceId);
      setAuthUser(response.data);

      // Fetch user module after login
      dispatch(fetchUserModule());

      history('/dashboard');

      return response.data;
    } else {   
      
      // toast.error(t(response.message));
      dispatch(apiError(t(response.message))); 
    }
  } catch (error) {
    dispatch(apiError(t(error)));
  }
};


export const logoutUser = () => async (dispatch) => {
  try {
    Cookies.remove("authorization");
    Cookies.remove("customToken");
    Cookies.remove("authUser");
    Cookies.remove("deviceId");
    dispatch(logoutUserSuccess(true));
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const socialLogin = (type, history) => async (dispatch) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      response = fireBaseBackend.socialLoginUser(type);
    }
    //  else {
      //   response = postSocialLogin(data);
      // }
      
      const socialdata = await response;
    if (socialdata) {
      sessionStorage.setItem("authUser", JSON.stringify(response));
      dispatch(loginSuccess(response));
      history('/dashboard')
    }

  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};